import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    wechatTipsVisible: false, // 提示遮罩层
    navShow: true,
  },
  getters: {
    wechatTipsVisible: state => state.wechatTipsVisible,
    navShow: state => state.navShow,
  },
  mutations: {
    setWechatTipsVisible(state, { visible }) {
      state.wechatTipsVisible = visible
    },
    setNavShow(state, { visible }) {
      state.navShow = visible
    }
  },
  actions: {
  },
  modules: {
  }
})
